/**
 * Which context menu a right-click on a node DATA cell should open, decided by
 * the active selection kind (PSTUDIO-3164 + reviewer follow-up):
 *   - a CELL selection (one or more cells selected) → the per-cell value menu
 *     (`CellValueContextMenu`);
 *   - rows selected, or nothing selected → the shared row menu
 *     (`RowContextMenu`).
 *
 * Extracted as a pure function so the routing decision is unit-testable in
 * isolation from the heavy `cell.tsx` component (DoD: unit coverage).
 */
export type NodeRightClickMenuKind = 'cell' | 'row';

export const resolveNodeRightClickMenuKind = (
  selectedCellCount: number
): NodeRightClickMenuKind => (selectedCellCount > 0 ? 'cell' : 'row');
